import React from "react"
// import { Link } from "gatsby"
import Layout from "../components/layout"
import Hero from "../components/hero"
import Img from "../assets/images/bgHeroBusesUrbanos.jpg"
import BlockBuses from '../components/buses/blockTpBuses'
import { BusUrbano, BusInterprovincial, BusParaPersonalDeLima } from '../data/buses'

const Data = [
  { ...BusUrbano.detailsItems[0], title: "OLYMPO URBANO", url: BusUrbano.url },
  BusInterprovincial.detailsItems[0],
  BusParaPersonalDeLima.detailsItems[0],
]
export default function Buses() {
  return (
    <>
       <Layout
        img={Img}
        title="Buses"
        description="Nuestros buses: OLYMPO URBANO, OLYMPO 3.6 MD, OLYMPO 3.5"
      >
        <Hero img={Img} title="buses"></Hero>
        {/* <div className="container"> */}
          <BlockBuses tipo='page' data={Data}></BlockBuses>
        {/* </div> */}
      </Layout>
    </>
  )
}
